import React from 'react';

const IconLogout = ({ color, width, height }) => {
  const colorfill = color || 'rgba(24, 25, 31, 0.54)';
  const widthIcon = width || '12';
  const heightIcon = height || '12';
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 12"
      width={widthIcon}
      height={heightIcon}
      fill={colorfill}
      aria-labelledby="title"
    >
      <title id="title">Sign-out</title>
      <path d="M5.98008 10.9834H1.49501C1.21992 10.9834 0.99668 10.7601 0.99668 10.485V1.51493C0.99668 1.23984 1.21995 1.0166 1.49501 1.0166H5.98008C6.25566 1.0166 6.47841 0.793851 6.47841 0.518272C6.47841 0.242694 6.25566 0.0198975 5.98008 0.0198975H1.49501C0.670758 0.0198975 0 0.690679 0 1.51493V10.485C0 11.3093 0.670758 11.98 1.49501 11.98H5.98008C6.25566 11.98 6.47841 11.7573 6.47841 11.4817C6.47841 11.2061 6.25566 10.9834 5.98008 10.9834Z" />
      <path d="M11.8515 5.64516L8.82158 2.65513C8.62622 2.46177 8.31029 2.46427 8.11693 2.66012C7.92357 2.85596 7.92556 3.17141 8.12192 3.36477L10.2872 5.50163H4.48503C4.20945 5.50163 3.9867 5.72438 3.9867 5.99996C3.9867 6.27554 4.20945 6.49831 4.48503 6.49831H10.2872L8.12192 8.63518C7.92558 8.82854 7.92408 9.14399 8.11693 9.33983C8.21459 9.4385 8.34317 9.48833 8.47175 9.48833C8.59833 9.48833 8.7249 9.44049 8.82158 9.3448L11.8515 6.35476C11.9462 6.26108 12 6.13349 12 5.99994C12 5.86644 11.9467 5.73936 11.8515 5.64516Z" />
    </svg>
  );
};

export default IconLogout;
